import './App.css';
import Router from './Router';
import { LoadingProvider } from './Services/loadingService';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from './Redux/store';
import { Provider } from 'react-redux';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <LoadingProvider>
            <Router />
            <ToastContainer />
        </LoadingProvider>
      </Provider>
    </div>
  );
}

export default App;
